import { createStore, combineReducers, applyMiddleware } from "redux";
import { all } from "redux-saga/effects";
import { composeWithDevTools } from "redux-devtools-extension";
import createSagaMiddleware from "redux-saga";
import watchCommonPageSaga from "./commonPageSaga";
import { handleActions } from "redux-actions";

import {
  SET_PAGE_LOADING,
  SET_PAGE_NAME,
  FETCH_MODULES_DATA_SUCCESS,
  UPDATE_PREFERENCES_SUCCESS,
  CHANGE_CONFIGURATOR_DISPLAY_NAME
} from "./commonPageSaga";

//commonReducer
const initialState = {
  isPageLoading: true,
  pageName: "",
  preferences: [],
  moduleProps: {},
  notifications: {},
  commonProps: {}
};

const commonReducer = handleActions(
  {
    [SET_PAGE_LOADING]: (state, action) => ({
      ...state,
      isPageLoading: action.payload
    }),
    [SET_PAGE_NAME]: (state, action) => ({
      ...state,
      pageName: action.payload
    }),
    [FETCH_MODULES_DATA_SUCCESS]: (state, action) => ({
      ...state,
      preferences: action.payload.preferences || initialState.preferences,
      moduleProps: action.payload.moduleProps || initialState.moduleProps,
      notifications: action.payload.notifications,
      commonProps: action.payload.commonProps
    }),
    [UPDATE_PREFERENCES_SUCCESS]: (state, { payload }) => ({
      ...state,
      preferences: payload.map((pref) => {
        const matchingPref = state.preferences.find(({ name }) => name === pref.name);
        return matchingPref && pref.displayName !== matchingPref.displayName
          ? { ...pref, displayName: matchingPref.displayName }
          : pref;
      })
    }),
    [CHANGE_CONFIGURATOR_DISPLAY_NAME]: (state, { payload: { prevModuleName, newModuleName } }) => {
      if (prevModuleName !== newModuleName) {
        return {
          ...state,
          preferences: state.preferences.map((pref) =>
            pref.displayName === prevModuleName ? { ...pref, displayName: newModuleName } : pref
          )
        };
      }
      return {
        ...state
      };
    }
  },
  initialState
);

function getReducersAndWatchers(modules) {
  let reducers = {};
  let sagas = [watchCommonPageSaga()];

  for (let module of modules) {
    reducers = { ...reducers, [module.moduleName]: module.reducer };
    sagas = [...sagas, module.saga];
  }

  return { reducers, sagas };
}

const sagaMiddleware = createSagaMiddleware();

export function createReduxStore(name, modules) {
  const composeEnhancers = composeWithDevTools({ name });
  const middleware = composeEnhancers(applyMiddleware(sagaMiddleware));

  const { reducers: currentReducers, sagas } = getReducersAndWatchers(modules);

  const reducers = combineReducers({
    commonReducer,
    ...currentReducers
  });

  let store = createStore(reducers, middleware);

  sagaMiddleware.run(function* rootSaga() {
    yield all(sagas);
  });

  return store;
}
